<ng-container>
  <div *ngIf="loading" class="loading">Loading terms and conditions...</div>
  <div *ngIf="!loading" [innerHTML]="htmlContent"></div>
</ng-container>
